import { AnimatedSection } from '@/components/ui';
import { BackgroundBeams } from '@/components/ui/background-beams';
import { Button as MovingBorderButton } from '@/components/ui/moving-border';
import { SparklesCore } from '@/components/ui/sparkles';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import posthog from 'posthog-js';
import { useReducedMotion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export const Cta = () => {
  const navigate = useNavigate();
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="relative overflow-hidden py-20 md:py-32">
      <div className="container relative">
        <AnimatedSection className="aceternity-surface relative mx-auto max-w-5xl overflow-hidden rounded-[2rem] border border-primary/15 px-6 py-16 text-center backdrop-blur-xl sm:px-10 md:py-24">
          <div className="pointer-events-none absolute inset-0" aria-hidden="true">
            <div className="aceternity-orb absolute -left-24 -top-24 h-[28rem] w-[28rem] opacity-70" />
            <div className="aceternity-orb absolute -bottom-28 -right-24 h-[24rem] w-[24rem] opacity-50" />
            {!prefersReducedMotion && (
              <>
                <BackgroundBeams className="opacity-35 [mask-size:48rem]" />
                <SparklesCore
                  id="cta-sparkles"
                  background="transparent"
                  minSize={0.4}
                  maxSize={1.2}
                  particleColor="#8b5cf6"
                  particleDensity={28}
                  speed={1.4}
                  className="absolute inset-0 h-full w-full opacity-30"
                />
              </>
            )}
          </div>

          <div className="relative mx-auto max-w-2xl">
            <div className="mb-5 inline-flex items-center rounded-full border border-primary/20 bg-background/70 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-primary shadow-sm shadow-primary/10 backdrop-blur-xl">
              Launch in minutes
            </div>
            <h2 className="mb-6 font-display text-4xl font-bold leading-[1.05] tracking-tight text-foreground sm:text-5xl md:text-6xl">
              Build your support chatbot in <span className="aceternity-gradient-text">minutes</span>
            </h2>
            <p className="mb-10 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Upload your docs, embed one script tag, and your AI chatbot handles customer questions around the clock.
            </p>
            <div className="flex justify-center">
              <MovingBorderButton
                borderRadius="0.9rem"
                duration={prefersReducedMotion ? 900000 : 3600}
                containerClassName="h-14 w-full max-w-[210px] text-base"
                borderClassName="bg-[radial-gradient(hsl(var(--primary))_40%,transparent_70%)] opacity-90"
                className="border border-primary/20 bg-primary text-base font-bold text-primary-foreground shadow-lg shadow-primary/25 transition-transform hover:scale-[1.02] hover:bg-primary/95 active:scale-[0.98]"
                onClick={() => {
                  posthog.capture('cta_clicked', { location: 'bottom_cta', target: 'dashboard' });
                  navigate('/dashboard');
                }}
              >
                Start free
                <ArrowTopRightIcon className="ml-1 h-4 w-4" />
              </MovingBorderButton>
            </div>
            <p className="mt-4 text-sm text-muted-foreground">
              Free plan available &middot; Cancel anytime
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};
